module.exports ={
    login: {
        company:'Minew',
        platform:'ESL Cloud',
        account:'Account',
        password:'Password',
        login:'Log in',
        logining:'Logging in...',
        loginTip: {
            exist: 'The user dose not exist',
            passwordErr: 'Wrong password',
            // permission:'您没有权限使用该平台',
            permission:'Please contact the administrator to assign a store to you',
            msgErr:'wrong username or password',
            fail:'Login failed',
            storeClose: 'The store is closed, please contact the administrator',
            storeExist: 'The store you belong to does not exist',
            valid: 'User is invalid, please contact the administrator',
            chooseSys: 'Please contact the administrator to select the desired application scenario.'
        },
        validMsg: {
            userName:'Please enter username',
            userNameRule: 'Please enter numbers or letters',
            length1:'Please enter password between 6 and 20 characters',
            // nameLen:'长度在不能超过20个字符'
            password:'Please enter password',
            passRule:'The password can not contain space',
            passRule1:'The password can not contain chinese'
        },
        logoSrc: "/static/images/logo_en.png",
        chooseSysType: 'Please select an application scenario',
        // sysTypeOpts: ['Retail', 'Medical'],
        sysTypeOpts: [
            {
                label: 'Retail',
                value: 'retail'
            },{
                label: 'Medical',
                value: 'medical'
            },{
                label: 'Custom scene',
                value: 'custom'
            }
        ],
        sysTips: 'Tip: This option is only available when you first use it. Please select the desired application scenario.',
        sure: 'OK',
        cancel: 'Cancel',
        chooseSysTip: {
            operateFail: 'Failed to select scene',
            exist: 'The selected scene does not exist',
            choosed: 'You have selected the scene you are using, please log in directly'
        },
        customLabel: 'Scene field editing',
        labelEditLabel: {
            id: { zh: { label: 'id', value: 'ID' }, en: { label: 'id', value: 'ID' }, ja: { label: 'id', value: 'ID' } },
            barcode: { zh: { label: 'barcode', value: '条形码' }, en: { label: 'barcode', value: 'Barcode' }, ja: { label: 'barcode', value: 'バーコード' } },
            qrcode: { zh: { label: 'qrcode', value: '二维码' }, en: { label: 'qrcode', value: 'Qrcode' }, ja: { label: 'qrcode', value: 'QRコード' } },
            label1: { zh: { label: 'label1', value: '条形码文本' }, en: { label: 'label1', value: 'Barcode Text' }, ja: { label: 'label1', value: 'バーコードテキスト' } },
            label2: { zh: { label: 'label2', value: '二维码文本' }, en: { label: 'label2', value: 'Qrcode Text' }, ja: { label: 'label2', value: 'QRコードテキスト' } },
            label3: { zh: { label: 'label3', value: '预留1' }, en: { label: 'label3', value: 'Placeholder1' }, ja: { label: 'label3', value: '予約1' } },
            label4: { zh: { label: 'label4', value: '预留2' }, en: { label: 'label4', value: 'Placeholder2' }, ja: { label: 'label4', value: '予約2' } },
            label5: { zh: { label: 'label5', value: '预留3' }, en: { label: 'label5', value: 'Placeholder3' }, ja: { label: 'label5', value: '予約3' } },
            label6: { zh: { label: 'label6', value: '预留4' }, en: { label: 'label6', value: 'Placeholder4' }, ja: { label: 'label6', value: '予約4' } },
            label7: { zh: { label: 'label7', value: '预留5' }, en: { label: 'label7', value: 'Placeholder5' }, ja: { label: 'label7', value: '予約5' } },
            label8: { zh: { label: 'label8', value: '预留6' }, en: { label: 'label8', value: 'Placeholder6' }, ja: { label: 'label8', value: '予約6' } },
            label9: { zh: { label: 'label9', value: '预留7' }, en: { label: 'label9', value: 'Placeholder7' }, ja: { label: 'label9', value: '予約7' } },
            label10: { zh: { label: 'label10', value: '预留8' }, en: { label: 'label10', value: 'Placeholder8' }, ja: { label: 'label10', value: '予約8' } },
            label11: { zh: { label: 'label11', value: '预留9' }, en: { label: 'label11', value: 'Placeholder9' }, ja: { label: 'label11', value: '予約9' } },
            label12: { zh: { label: 'label12', value: '预留10' }, en: { label: 'label12', value: 'Placeholder10' }, ja: { label: 'label12', value: '予約10' } },
            label13: { zh: { label: 'label13', value: '预留11' }, en: { label: 'label13', value: 'Placeholder11' }, ja: { label: 'label13', value: '予約11' } },
            label14: { zh: { label: 'label14', value: '预留12' }, en: { label: 'label14', value: 'Placeholder12' }, ja: { label: 'label14', value: '予約12' } },
            label15: { zh: { label: 'label15', value: '预留13' }, en: { label: 'label15', value: 'Placeholder13' }, ja: { label: 'label15', value: '予約13' } },
            label16: { zh: { label: 'label16', value: '预留14' }, en: { label: 'label16', value: 'Placeholder14' }, ja: { label: 'label16', value: '予約14' } },
            label17: { zh: { label: 'label17', value: '预留15' }, en: { label: 'label17', value: 'Placeholder15' }, ja: { label: 'label17', value: '予約15' } },
            label18: { zh: { label: 'label18', value: '预留16' }, en: { label: 'label18', value: 'Placeholder16' }, ja: { label: 'label18', value: '予約16' } },
            photo1: { zh: { label: 'photo1', value: '图片1' }, en: { label: 'photo1', value: 'photo1' }, ja: { label: 'photo1', value: '画像1' } },
            photo2: { zh: { label: 'photo2', value: '图片2' }, en: { label: 'photo2', value: 'photo2' }, ja: { label: 'photo2', value: '画像2' } },
            photo3: { zh: { label: 'photo3', value: '图片3' }, en: { label: 'photo3', value: 'photo3' }, ja: { label: 'photo3', value: '画像3' } },
            photo4: { zh: { label: 'photo4', value: '图片4' }, en: { label: 'photo4', value: 'photo4' }, ja: { label: 'photo4', value: '画像4' } },
            photo5: { zh: { label: 'photo5', value: '图片5' }, en: { label: 'photo5', value: 'photo5' }, ja: { label: 'photo5', value: '画像5' } },
        },
        labelEditValidMsg: {
            label1: 'Please enter label1',
            label2: 'Please enter label2',
            label3: 'Please enter label3',
            label4: 'Please enter label4',
            label5: 'Please enter label5',
            label6: 'Please enter label6',
            label7: 'Please enter label7',
            label8: 'Please enter label8',
            label9: 'Please enter label9',
            label10: 'Please enter label10',
            label11: 'Please enter label11',
            label12: 'Please enter label12',
            label13: 'Please enter label13',
            label14: 'Please enter label14',
            label15: 'Please enter label15',
            label16: 'Please enter label16',
            label17: 'Please enter label17',
            label18: 'Please enter label18',
            label19: 'Please enter label19',
            label20: 'Please enter label20',
            input: 'Please enter {name}',
            sence: 'Please enter sence',
            senceExist: 'Scene name already exists',
            senceFail: 'Failed to get, please re-enter',
            senceLang: 'Please select the scene field language'
        },
        labelEditTips: {
            getLabelNameFail: 'Failed to get field name',
            success: 'Field name edited successfully',
            fail: 'Field name edit failed'
        },
        sence: {
            edit: 'Scene editing',
            name: 'Scene name',
            labelLang: 'Scene field language'
        },
        senceLang: [
            {
                langVal: 'en',
                langLabel: 'English',
                editTitle: 'English field editing'
            },{
                langVal: 'zh',
                langLabel: 'Chinese',
                editTitle: 'Chinese field editing'
            },{
                langVal: 'ja',
                langLabel: 'Japanese',
                editTitle: 'Japanese field editing'
            }
        ],
        submiting: 'Submiting...',
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/login.js